var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 93,
    viewBox: "0 0 71 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5155",
    "data-name": "Group 5155",
    transform: "translate(-1277.5 -2303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4581",
    "data-name": "Group 4581",
    transform: "translate(2.5 816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4728",
    "data-name": "Path 4728",
    d: "M1259.712,916.225a1.122,1.122,0,0,0,0,2.244h34.076a1.122,1.122,0,0,0,0-2.244Z",
    transform: "translate(33.989 633.622)",
    fill: "#313830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4729",
    "data-name": "Path 4729",
    d: "M1249.7,625.925h-9.936v-2.119a1.122,1.122,0,0,0-2.244,0v2.119h-12.641v-2.119a1.122,1.122,0,1,0-2.244,0v2.119H1210v-2.119a1.122,1.122,0,1,0-2.244,0v2.119h-9.936a1.122,1.122,0,0,0-1.122,1.122v48.642a1.122,1.122,0,0,0,1.122,1.122H1249.7a1.122,1.122,0,0,0,1.122-1.122V627.047A1.122,1.122,0,0,0,1249.7,625.925Zm-1.122,48.642h-49.64v-46.4h8.814v2.143a2.244,2.244,0,1,0,2.244,0v-2.143h12.64v2.143a2.244,2.244,0,1,0,2.244,0v-2.143h12.641v2.143a2.243,2.243,0,1,0,2.244,0v-2.143h8.814Z",
    transform: "translate(88.27 883.795)",
    fill: "#313830"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_12",
    "data-name": 12,
    transform: "translate(1275 1518)",
    fill: "#313830",
    fontSize: 26,
    fontFamily: "FiraSansCondensed-Bold, Fira Sans Condensed",
    fontWeight: 700,
    letterSpacing: "0.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 23.15,
    y: 24
  }, "12")), /*#__PURE__*/React.createElement("text", {
    id: "SEP",
    transform: "translate(1279 1487)",
    fill: "#313830",
    fontSize: 15,
    fontFamily: "FiraSansCondensed-Bold, Fira Sans Condensed",
    fontWeight: 700,
    letterSpacing: "0.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19.96,
    y: 14
  }, "SEP")), /*#__PURE__*/React.createElement("text", {
    id: "_2019",
    "data-name": 2019,
    transform: "translate(1278 1562)",
    fill: "#313830",
    fontSize: 15,
    fontFamily: "FiraSansCondensed-Bold, Fira Sans Condensed",
    fontWeight: 700,
    letterSpacing: "0.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16.218,
    y: 14
  }, "2019"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.1024636cc0c4de1baa3e513cde0112f0.svg";
export { ForwardRef as ReactComponent };